/** Path-based product landings (always available at these URLs on any host). */
export const LANDING_PATHS = {
  main: "/",
  mainPreview: "/lp/main-landing",
  partner: "/lp/partner-landing",
  roofing: "/lp/roofing-landing",
  roofingLight: "/lp/roofing-light",
  roofingSpeedToLeadBenchmark: "/lp/roofing-speed-to-lead-benchmark-report",
  realEstate: "/lp/real-estate-landing",
  interceptProtocol: "/lp/intercept-protocol",
};

/**
 * Root `/` is chosen by brand (see lib/siteHosts.js):
 * - staging.fractolabs.com, apex, www, localhost, and 127.0.0.1 → main
 * - app.settrhq.com and staging.settrhq.com → settrhq
 * - partner / roofing / inbnd / ai on *.fractolabs.com stay mapped
 * - an unknown host is stub, with no unlock from ?l= or the lead cookie
 */
export const appLoginPath = (returnPath = "/dashboard") => {
  const encoded = encodeURIComponent(returnPath);
  return `/login?returnTo=${encoded}`;
};
